// Clasifica la descripción de un estado de orden (tabla estados_ordenes,
// usada tanto por ordenes_prestador como por ordenes_comercio) en una
// categoría visual, para poder pintar el tag de estado con un color que
// ayude a distinguir de un vistazo si la orden está en curso, resuelta
// bien, resuelta mal, o descartada.
//
// Matchea por texto (no por id) para no depender del orden de inserción en
// la base. Estados actuales (ver libresalud.sql, tabla estados_ordenes):
// Iniciado, Respondido, Aceptado, Completado, Cancelado, Pago Aprobado,
// Procesando Pago, Pago Rechazado, Calificado, Desestimado, Pago Cancelado.
export function claseEstadoOrden(descripcion?: string | null): string {
  const d = (descripcion ?? '').trim().toLowerCase();

  switch (d) {
    case 'completado':
    case 'pago aprobado':
      return 'estado-exito';
    case 'calificado':
      return 'estado-calificado';
    case 'cancelado':
    case 'pago rechazado':
    case 'pago cancelado':
      return 'estado-error';
    case 'desestimado':
      return 'estado-desestimado';
    case 'procesando pago':
      return 'estado-pendiente';
    case 'respondido':
    case 'aceptado':
      return 'estado-progreso';
    case 'iniciado':
    default:
      return 'estado-neutro';
  }
}
